import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

const Languages = (props) => {
	const languages = props.data.languages;

	if (!_.isArray(languages) || _.isEmpty(languages)) {
		return null;
	}

	return (
		<ul className="bio-list">
			{_.map(languages, ({ la_language_description: languageDescription }) => (
				<li className="bio-list__item" key={_.uniqueId('list-item-')}>{languageDescription}</li>
			))}
		</ul>
	);
};

Languages.propTypes = {
	data: PropTypes.object.isRequired,
};

export default Languages;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/people/parts/languages.js